export default __webpack_public_path__ + "static/networking-c46182728111bf8df53ce0ed4c638fa2.jpg";